"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CompositionsModal = function CompositionsModal(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      withContentBorder = _ref.withContentBorder,
      maxWidth = _ref.maxWidth,
      height = _ref.height,
      onBack = _ref.onBack,
      children = _ref.children,
      actions = _ref.actions,
      title = _ref.title,
      subtitle = _ref.subtitle,
      fullWidth = _ref.fullWidth,
      fullScreen = _ref.fullScreen,
      dataElementPrefix = _ref.dataElementPrefix,
      variant = _ref.variant,
      contentSpacing = _ref.contentSpacing,
      disableBackdropClick = _ref.disableBackdropClick,
      ModalProps = _ref.ModalProps,
      ContentProps = _ref.ContentProps;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  var fullScreenModal = typeof fullScreen !== 'undefined' ? fullScreen : isMobile;
  return _react.default.createElement(_moduleModal.default, _extends({
    open: open,
    onClose: onClose,
    maxWidth: maxWidth,
    variant: variant,
    fullScreen: fullScreenModal,
    fullWidth: fullWidth,
    height: height,
    disableBackdropClick: disableBackdropClick,
    dataElementPrefix: dataElementPrefix
  }, ModalProps), _react.default.createElement(_moduleModal.default.Header, {
    bordered: withContentBorder
  }, onBack && _react.default.createElement(_moduleModal.default.Alignment, null, _react.default.createElement(_moduleModal.default.Header.Back, {
    onClick: onBack
  })), _react.default.createElement(_moduleModal.default.Alignment, {
    alignSelf: "center"
  }, _react.default.createElement(_moduleModal.default.Header.Title, {
    title: title,
    subtitle: subtitle
  })), _react.default.createElement(_moduleModal.default.Alignment, {
    rightAligned: true
  }, _react.default.createElement(_moduleModal.default.Header.Close, null))), _react.default.createElement(_moduleModal.default.Content, _extends({
    contentSpacing: fullScreenModal ? 'small' : contentSpacing
  }, ContentProps), children), actions && actions.length > 0 && _react.default.createElement(_moduleModal.default.Footer, {
    bordered: true
  }, _react.default.createElement(_moduleModal.default.Alignment, {
    rightAligned: true
  }, actions)));
};

CompositionsModal.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired,
  actions: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  title: _propTypes.default.node.isRequired,
  withContentBorder: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['default', 'transparent', 'light']),
  contentSpacing: _propTypes.default.oneOf(['xs', 'small', 'medium', 'large']),
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  height: _propTypes.default.string,
  subtitle: _propTypes.default.node,
  onBack: _propTypes.default.func,
  dataElementPrefix: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  fullScreen: _propTypes.default.bool,
  disableBackdropClick: _propTypes.default.bool,
  ModalProps: _propTypes.default.object,
  ContentProps: _propTypes.default.object
};
CompositionsModal.defaultProps = {
  fullWidth: true,
  fullScreen: undefined,
  maxWidth: 'sm',
  contentSpacing: 'small',
  variant: 'default',
  ModalProps: {},
  ContentProps: {}
};
var _default = CompositionsModal;
exports.default = _default;